import { addOnReducer } from "./addOnReducer";
import { contactReducer } from "./contactReducer";
import { twoWayReportReducer } from "./twoWayMessaging/twoWayReportReducer";
import rpaReducers from "./rpa";
import whatsAppReducers from "./whatsApp";
import itrustPayReducers from "./itrustPay";
import voipReducers from "./voip";
import aiReceptionistReducer from "./aiReceptionist";
import EdiClearingHouseReducers from "./EDIClearingHouse";

const addOnsReducers = {
  addOn: addOnReducer,
  contact: contactReducer,
  twoWayReport: twoWayReportReducer,
  ...voipReducers,
  ...itrustPayReducers,
  ...whatsAppReducers,
  ...EdiClearingHouseReducers,
  ...rpaReducers,
  ...aiReceptionistReducer,
};

export default addOnsReducers;